/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CallCustomersRequestBuilderRequestsMetadata, type CallCustomersRequestBuilder } from './callCustomers/index.js';
// @ts-ignore
import { ChargepointDeviceIdsRequestBuilderRequestsMetadata, type ChargepointDeviceIdsRequestBuilder } from './chargepointDeviceIds/index.js';
// @ts-ignore
import { ChargerDefinitionLinksRequestBuilderRequestsMetadata, type ChargerDefinitionLinksRequestBuilder } from './chargerDefinitionLinks/index.js';
// @ts-ignore
import { ChargerMakesAndModelsRequestBuilderRequestsMetadata, type ChargerMakesAndModelsRequestBuilder } from './chargerMakesAndModels/index.js';
// @ts-ignore
import { ContractDocumentsRequestBuilderRequestsMetadata, type ContractDocumentsRequestBuilder } from './contractDocuments/index.js';
// @ts-ignore
import { SessionDatesRequestBuilderRequestsMetadata, type SessionDatesRequestBuilder } from './sessionDates/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills
 */
export interface BackfillsRequestBuilder extends BaseRequestBuilder<BackfillsRequestBuilder> {
    /**
     * The callCustomers property
     */
    get callCustomers(): CallCustomersRequestBuilder;
    /**
     * The chargepointDeviceIds property
     */
    get chargepointDeviceIds(): ChargepointDeviceIdsRequestBuilder;
    /**
     * The chargerDefinitionLinks property
     */
    get chargerDefinitionLinks(): ChargerDefinitionLinksRequestBuilder;
    /**
     * The chargerMakesAndModels property
     */
    get chargerMakesAndModels(): ChargerMakesAndModelsRequestBuilder;
    /**
     * The contractDocuments property
     */
    get contractDocuments(): ContractDocumentsRequestBuilder;
    /**
     * The sessionDates property
     */
    get sessionDates(): SessionDatesRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BackfillsRequestBuilderUriTemplate = "{+baseurl}/backfills";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BackfillsRequestBuilderNavigationMetadata: Record<Exclude<keyof BackfillsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    callCustomers: {
        requestsMetadata: CallCustomersRequestBuilderRequestsMetadata,
    },
    chargepointDeviceIds: {
        requestsMetadata: ChargepointDeviceIdsRequestBuilderRequestsMetadata,
    },
    chargerDefinitionLinks: {
        requestsMetadata: ChargerDefinitionLinksRequestBuilderRequestsMetadata,
    },
    chargerMakesAndModels: {
        requestsMetadata: ChargerMakesAndModelsRequestBuilderRequestsMetadata,
    },
    contractDocuments: {
        requestsMetadata: ContractDocumentsRequestBuilderRequestsMetadata,
    },
    sessionDates: {
        requestsMetadata: SessionDatesRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
